import { render, staticRenderFns } from "./GenerallLedgerDetailedModal.vue?vue&type=template&id=0be74993&scoped=true&"
import script from "./GenerallLedgerDetailedModal.vue?vue&type=script&lang=js&"
export * from "./GenerallLedgerDetailedModal.vue?vue&type=script&lang=js&"
import style0 from "./GenerallLedgerDetailedModal.vue?vue&type=style&index=0&id=0be74993&prod&lang=less&scoped=true&"
import style1 from "./GenerallLedgerDetailedModal.vue?vue&type=style&index=1&id=0be74993&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be74993",
  null
  
)

export default component.exports